import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';

// bootstrap
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
// fontawesome
import '../node_modules/font-awesome/css/font-awesome.min.css';
// css
import './css/App.css';

import App from './components/App';

const render = Component => {
    ReactDOM.render(
        <BrowserRouter>
            <Component />
        </BrowserRouter>,
        document.getElementById('root')
    );
};

render(App);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js